import ProductListContainer from "./ProductListContainer";

export default ProductListContainer;
